import { Component, inject } from '@angular/core';
import { SaleOrderParametrizationService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SaleOrderParametrizationCreateDto,
  SaleOrderParametrizationDto,
  SaleOrderParametrizationExcelDownloadDto,
  SaleOrderParametrizationUpdateDto,
} from '../proxy/controlling/dtos/sale-order-parametrization';
import { SALEORDERPARAMETRIZATION_CONFIG, SALEORDERPARAMETRIZATION_FIELDS } from './sale-order-parametrization.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sale-order-parametrization',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SaleOrderParametrizationService, ConfirmationService],
  templateUrl: './sale-order-parametrization.html',
  styleUrl: './sale-order-parametrization.scss',
})
export class SaleOrderParametrization extends BaseCrudComponent<
  SaleOrderParametrizationDto,
  SaleOrderParametrizationCreateDto,
  SaleOrderParametrizationUpdateDto,
  SaleOrderParametrizationExcelDownloadDto
> {
  service = inject(SaleOrderParametrizationService);
  config = SALEORDERPARAMETRIZATION_CONFIG;
  fields = SALEORDERPARAMETRIZATION_FIELDS;

  protected prepareUpdateDto(data: any, selected: SaleOrderParametrizationDto): SaleOrderParametrizationUpdateDto {
    return {
      termsOfPaymentParameterValueId: data.termsOfPaymentParameterValueId,
      headerText: data.headerText,
      contractId: data.contractId,
      saleTypeId: data.saleTypeId,
      currencyId: data.currencyId,
      customerId: data.customerId,
      purchaseOrderId: data.purchaseOrderId,
      documentTypeId: data.documentTypeId,
      profitCenterId: data.profitCenterId,
      companyCodeId: data.companyCodeId,
      sapPlantId: data.sapPlantId,
      distributionChannelParameterValueId: data.distributionChannelParameterValueId,
      divisionParameterValueId: data.divisionParameterValueId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SaleOrderParametrization';
  }
}
